// extracted by mini-css-extract-plugin
export default {"AccountsSectionSuccess":"AccountsSectionSuccess_AccountsSectionSuccess__w4a16","fade-in":"AccountsSectionSuccess_fade-in__MzAbV"};